import { render, staticRenderFns } from "./EditOffRoad.vue?vue&type=template&id=6b8c9d74&scoped=true"
import script from "./EditOffRoad.vue?vue&type=script&lang=js"
export * from "./EditOffRoad.vue?vue&type=script&lang=js"
import style0 from "./EditOffRoad.vue?vue&type=style&index=0&id=6b8c9d74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8c9d74",
  null
  
)

export default component.exports